import { getBasePath } from '../../../utils/miscellaneous-utils'
import { TraumTagTypes } from '../../../utils/traum-tag-utils'

export interface BannerTag {
    id: TraumTagTypes
    iconSrc: string
    /** i18n key prefix; `.title` and `.description` hang off it. */
    translationKey: string
}

const icon = (name: string) => getBasePath(`/assets/images/traum-tags/${name}.png`)

/**
 * Tags the PDP banner can display, in rotation order.
 *
 * This is deliberately separate from `traum-tag-utils`, which categorises tags into
 * badge/bottom groups for the SRL cards — the banner shows one flat rotating list and
 * needs its own copy keys. Tag types absent from this list (Popular Choice) have no
 * banner design and are skipped.
 */
export const BANNER_TAGS: BannerTag[] = [
    { id: TraumTagTypes.SUPER_HOST, iconSrc: icon('super-host'), translationKey: 'traumTagBanner.superHost' },
    { id: TraumTagTypes.AWARD, iconSrc: icon('award'), translationKey: 'traumTagBanner.award' },
    { id: TraumTagTypes.LUXE, iconSrc: icon('luxus'), translationKey: 'traumTagBanner.luxe' },
    {
        id: TraumTagTypes.VALUE_FOR_MONEY,
        iconSrc: icon('value-for-money'),
        translationKey: 'traumTagBanner.valueForMoney',
    },
    { id: TraumTagTypes.HIDDEN_GEM, iconSrc: icon('tressure'), translationKey: 'traumTagBanner.hiddenGem' },
    { id: TraumTagTypes.DOG_FRIENDLY, iconSrc: icon('dog-friendly'), translationKey: 'traumTagBanner.dogFriendly' },
    { id: TraumTagTypes.BEACH_HOLIDAY, iconSrc: icon('beach-holiday'), translationKey: 'traumTagBanner.beachHoliday' },
    { id: TraumTagTypes.SKI_FRIENDLY, iconSrc: icon('ski-friendly'), translationKey: 'traumTagBanner.skiFriendly' },
    { id: TraumTagTypes.FAMILY_HAVEN, iconSrc: icon('family-haven'), translationKey: 'traumTagBanner.familyHaven' },
    { id: TraumTagTypes.FARM_HOLIDAY, iconSrc: icon('farm-holiday'), translationKey: 'traumTagBanner.farmHoliday' },
    {
        id: TraumTagTypes.FISHING_HOLIDAY,
        iconSrc: icon('fishing-holiday'),
        translationKey: 'traumTagBanner.fishingHoliday',
    },
    { id: TraumTagTypes.SEA_VIEWS, iconSrc: icon('sea-views'), translationKey: 'traumTagBanner.seaViews' },
    {
        id: TraumTagTypes.HOLIDAY_BY_LAKE,
        iconSrc: icon('holiday-by-lake'),
        translationKey: 'traumTagBanner.holidayByLake',
    },
    { id: TraumTagTypes.POOL_HOUSE, iconSrc: icon('pool-house'), translationKey: 'traumTagBanner.poolHouse' },
    {
        id: TraumTagTypes.WELLNESS_ESCAPE,
        iconSrc: icon('wellness-escape'),
        translationKey: 'traumTagBanner.wellnessEscape',
    },
    {
        id: TraumTagTypes.MOUNTAIN_VIEWS,
        iconSrc: icon('mountain-views'),
        translationKey: 'traumTagBanner.mountainViews',
    },
    {
        id: TraumTagTypes.GUEST_FRIENDLY,
        iconSrc: icon('guest-favourite'),
        translationKey: 'traumTagBanner.guestFavourite',
    },
]

/** The property's tags that the banner can render, in `BANNER_TAGS` order. */
export const getBannerTags = (traumTagIds: number[]): BannerTag[] =>
    BANNER_TAGS.filter(tag => traumTagIds.includes(tag.id))
